import React, { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import cx from "classnames";
import {
  Col,
  DropdownMenu,
  DropdownToggle,
  Nav,
  NavItem,
  NavLink,
  Row,
  UncontrolledDropdown,
  Input as RInput,
  Dropdown,
  DropdownItem,
  Button,
} from "reactstrap";
import PropTypes from "prop-types";

import global from "../../../scss/dhp.scss";

import { Icon } from "../../ui/icon";
import { Input } from "../../ui/input";
import Progressbar from "../../ui/progressbar";
import { TEXT, TEXT_ART } from "../../../constants/editor";
import FontFamily from "../ContextualMenu/FontFamily";
import { contextualConfig, widgetConfig } from "../editor_config";
import SliderControll from "../SliderControll";
import ColorBucket from "../ContextualMenu/ColorBucket";
import { changeBucketColorAccordingBackground, hexToRGB, splitLinerGradientValues } from "../../../_helpers/utils";
import {
  fetchAssetsList,
  filterAssetsList,
  insertTextArtImage,
  uploadTextArtImage,
} from "../../../store/actions/editorActions";
import AssetsLoader from "../../ui/loader/assetsLoader";
import useTextArtTransform from "../../../hooks/useTextArtTransform";
import useAlignment from "../../../hooks/useAlignment";
import useAddWidget from "../../../hooks/useAddWidget";
import useElementInnerHtml from "../../../hooks/useElementInnerHtml";
import { EditorContext } from "../../../containers/editor/EditorLayout";

import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation } from "swiper";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
SwiperCore.use([Navigation]);

let style = Object.assign({}, global);

const ProgressLoader = props => {
  const [uploadProgress, setUploadProgress] = useState(0);
  const [showLoader, setShowLoader] = useState(true);
  const intervalRef = useRef(null);

  const calculateProgress = val => {
    let progress = val ?? 0;
    let maxProgress = 95;
    intervalRef.current = setInterval(() => {
      if (progress < maxProgress) {
        progress += 3;
        if (progress > maxProgress) {
          progress = maxProgress;
        }
      }
      setUploadProgress(progress);
      if (progress >= maxProgress) {
        clearInterval(intervalRef.current);
      }
    }, 400);
  };

  useEffect(() => {
    calculateProgress();
  }, []);

  useEffect(() => {
    if (props.assetId) {
      clearInterval(intervalRef.current);
      setUploadProgress(100);
      setTimeout(() => setShowLoader(false), 1000);
    }
  }, [props.assetId]);

  return <>{showLoader && <Progressbar progressbarInfo={uploadProgress} />}</>;
};
ProgressLoader.propTypes = {
  assetId: PropTypes.string,
};

const TextFill = props => {
  let options = [
    {
      text: "Solid Color",
      name: "solid",
      value: "solid",
    },
    {
      text: "Gradient",
      name: "gradient",
      value: "gradient",
    },
    {
      text: "Image",
      name: "image",
      value: "image",
    },
  ];
  let solidColorCount = [1, 2, 3];
  let default_config = {
    c1: "#72ac4d",
    c2: "#fdbf2d",
    c3: "#ff030e",
    r1: 33,
    r2: 33,
    r3: 34,
    image: "https://assets.dochipo.com/editor/text_art/text-fill.jpg",
  };

  const dispatch = useDispatch();

  const [fillType, setFillType] = useState();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [updateContext, setUpdateContext] = useState(false);
  const [colorCount, setColorCount] = useState();
  const [color1, setColor1] = useState();
  const [bucketColor1, setBucketColor1] = useState();
  const [bucketColor1EyeDropper, setBucketColor1EyeDropper] = useState();
  const [color1Range, setColor1Range] = useState();
  const [color2, setColor2] = useState();
  const [bucketColor2, setBucketColor2] = useState();
  const [bucketColor2EyeDropper, setBucketColor2EyeDropper] = useState();
  const [color2Range, setColor2Range] = useState();
  const [color3, setColor3] = useState();
  const [bucketColor3, setBucketColor3] = useState();
  const [bucketColor3EyeDropper, setBucketColor3EyeDropper] = useState();
  const [color3Range, setColor3Range] = useState();
  const [updateFromColorCountDropdown, setUpdateFromColorCountDropdown] = useState();
  const [colorPickerGradient, setColorPickerGradient] = useState();
  const [isGradientActive, setIsGradientActive] = useState();
  const [iamgeUrl, setIamgeUrl] = useState();
  const [iamgeZoom, setIamgeZoom] = useState();
  const [uploadAssetError, setUploadAssetError] = useState();
  const [isUploadDone, setIsUploadDone] = useState();
  const [gradientHtml, setGradientHtml] = useState();

  const toggle2 = () => setDropdownOpen(prevState => !prevState);

  const apllyColor = (p1, p2, p3) => {
    // for 1 color
    if (colorCount === 1) {
      let el = document.querySelector(".text-content");

      // apply color in path text
      if (
        el?.getAttribute("data-transform-type") &&
        ["Path 2", "Path 3", "Path 4", "Warp 9", "Warp 10"].includes(el?.getAttribute("data-transform-type"))
      ) {
        document.querySelector(".text-content svg text").setAttribute("fill", color1);
      }
      // apply color in warp text
      else if (
        el?.getAttribute("data-transform-type") &&
        ["Warp 1", "Warp 2", "Warp 3", "Warp 4", "Warp 5", "Warp 6", "Warp 7", "Warp 8"].includes(
          el?.getAttribute("data-transform-type")
        )
      ) {
        document.querySelector(".text-content svg path").setAttribute("fill", color1);
      }
      // apply color in normal text
      else {
        let cssstyle = {
          color: color1,
          "background-image": "",
          "-webkit-text-fill-color": "",
          "background-clip": "",
          "-webkit-background-clip": "",
          "font-family": el.style.fontFamily,
          "font-size": el.style.fontSize,
          "font-weight": el.style.fontWeight,
          "letter-spacing": el.style.letterSpacing ?? "0px",
        };

        // if outline apllied
        if (el.getAttribute("data-outline")) {
          cssstyle = {
            ...cssstyle,
            "-webkit-text-stroke": `${el.getAttribute("data-outline-width")}px ${el.getAttribute(
              "data-outline-color"
            )}`,
          };
        }

        // Clear all inline styles
        el.removeAttribute("style");

        // Apply new ones
        Object.entries(cssstyle).forEach(([prop, value]) => {
          el.style.setProperty(prop, value);
        });
      }

      if (fillType === "solid") {
        // Add data attributes
        let data = {
          "data-fill-type": fillType,
          "data-color-count": colorCount,
          "data-color-one": color1,
        };
        Object.entries(data).forEach(([prop, value]) => {
          el.setAttribute(prop, value);
        });

        // Remove some data attributes
        let attributesToRemove = [
          "data-color-one-range",
          "data-color-two-range",
          "data-color-three-range",
          "data-color-two",
          "data-color-three",
          "data-grad-degree",
          "data-grad-scolor",
          "data-grad-spercen",
          "data-grad-ecolor",
          "data-grad-epercen",
        ];
        attributesToRemove.forEach(attr => {
          el.removeAttribute(attr);
        });
      }

      if (updateContext && fillType === "solid") props.setTextHtml(document.querySelector(".text-content"));
    }
    // for 2 color
    else if (colorCount === 2) {
      let el = document.querySelector(".text-content");

      let cssstyle = {
        "background-image": `linear-gradient(to bottom, ${color1} ${p1}%, ${color2} 1%`,
        "-webkit-text-fill-color": "transparent",
        "background-clip": "text",
        "-webkit-background-clip": "text",
        "font-family": el.style.fontFamily,
        "font-size": el.style.fontSize,
        "font-weight": el.style.fontWeight,
        "letter-spacing": el.style.letterSpacing ?? "0px",
      };

      // if outline apllied
      if (el.getAttribute("data-outline")) {
        cssstyle = {
          ...cssstyle,
          "-webkit-text-stroke": `${el.getAttribute("data-outline-width")}px ${el.getAttribute("data-outline-color")}`,
        };
      }

      // Clear all inline styles
      el.removeAttribute("style");

      // Apply new ones
      Object.entries(cssstyle).forEach(([prop, value]) => {
        el.style.setProperty(prop, value);
      });

      // Add data attributes
      let data = {
        "data-fill-type": fillType,
        "data-color-count": colorCount,
        "data-color-one": color1,
        "data-color-one-range": p1,
        "data-color-two": color2,
        "data-color-two-range": p2,
      };
      Object.entries(data).forEach(([prop, value]) => {
        el.setAttribute(prop, value);
      });

      // Remove some data attributes
      let attributesToRemove = [
        "data-color-three-range",
        "data-color-three",
        "data-grad-degree",
        "data-grad-scolor",
        "data-grad-spercen",
        "data-grad-ecolor",
        "data-grad-epercen",
      ];
      attributesToRemove.forEach(attr => {
        el.removeAttribute(attr);
      });

      updateContext && color2 && props.setTextHtml(document.querySelector(".text-content"));
    }
    // for 3 color
    else if (colorCount === 3) {
      let el = document.querySelector(".text-content");

      // sometimes p1,p2,p3 is not getting (when the value is present color value is not present)
      if (!p3) {
        p1 = p1 ?? parseInt(el.getAttribute("data-color-one-range"));
        p2 = p2 ?? parseInt(el.getAttribute("data-color-two-range"));
        p3 = p3 ?? parseInt(el.getAttribute("data-color-three-range"));

        setColor1Range(p1);
        setColor2Range(p2);
        setColor3Range(p3);
      }

      let cssstyle = {
        "background-image": `linear-gradient(to bottom,
        ${color1} ${p1}%,
        ${color2} ${p1}%, ${color2} ${p1 + p2}%,
        ${color3} ${p1 + p2}%)`,
        "-webkit-text-fill-color": "transparent",
        "background-clip": "text",
        "-webkit-background-clip": "text",
        "font-family": el.style.fontFamily,
        "font-size": el.style.fontSize,
        "font-weight": el.style.fontWeight,
        "letter-spacing": el.style.letterSpacing ?? "0px",
      };

      // if outline apllied
      if (el.getAttribute("data-outline")) {
        cssstyle = {
          ...cssstyle,
          "-webkit-text-stroke": `${el.getAttribute("data-outline-width")}px ${el.getAttribute("data-outline-color")}`,
        };
      }

      // Clear all inline styles
      el.removeAttribute("style");

      // Apply new ones
      Object.entries(cssstyle).forEach(([prop, value]) => {
        el.style.setProperty(prop, value);
      });

      // Add data attributes
      let data = {
        "data-fill-type": fillType,
        "data-color-count": colorCount,
        "data-color-one": color1,
        "data-color-one-range": p1,
        "data-color-two": color2,
        "data-color-two-range": p2,
        "data-color-three": color3,
        "data-color-three-range": p3 ?? color3Range,
      };
      Object.entries(data).forEach(([prop, value]) => {
        el.setAttribute(prop, value);
      });

      // Remove some data attributes
      let attributesToRemove = [
        "data-grad-degree",
        "data-grad-scolor",
        "data-grad-spercen",
        "data-grad-ecolor",
        "data-grad-epercen",
      ];
      attributesToRemove.forEach(attr => {
        el.removeAttribute(attr);
      });

      updateContext && color2 && color3 && props.setTextHtml(document.querySelector(".text-content"));
    }

    setUpdateFromColorCountDropdown(false);
  };

  const applyGradienColor = () => {
    if (colorPickerGradient && isGradientActive) {
      let { gradDeg, startColor, startPercent, endColor, endPercent } = splitLinerGradientValues(colorPickerGradient);
      if (!startColor || startColor === "undefined") return;

      let activeNode = document.querySelector(".text-content");

      let cssstyle = {
        "background-image": colorPickerGradient,
        "-webkit-text-fill-color": "transparent",
        "background-clip": "text",
        "-webkit-background-clip": "text",
        "font-family": activeNode.style.fontFamily,
        "font-size": activeNode.style.fontSize,
        "font-weight": activeNode.style.fontWeight,
        "letter-spacing": activeNode.style.letterSpacing ?? "0px",
      };

      // if outline apllied
      if (activeNode.getAttribute("data-outline")) {
        cssstyle = {
          ...cssstyle,
          "-webkit-text-stroke": `${activeNode.getAttribute("data-outline-width")}px ${activeNode.getAttribute(
            "data-outline-color"
          )}`,
        };
      }

      // Clear all inline styles
      activeNode.removeAttribute("style");

      // Apply new ones
      Object.entries(cssstyle).forEach(([prop, value]) => {
        activeNode.style.setProperty(prop, value);
      });

      // Add data attributes
      let data = {
        "data-fill-type": fillType,
        "data-grad-degree": gradDeg,
        "data-grad-scolor": startColor,
        "data-grad-spercen": startPercent,
        "data-grad-ecolor": endColor,
        "data-grad-epercen": endPercent,
      };
      Object.entries(data).forEach(([prop, value]) => {
        activeNode.setAttribute(prop, value);
      });

      // Remove some data attributes
      let attributesToRemove = [
        "data-color-one-range",
        "data-color-two-range",
        "data-color-three-range",
        "data-color-count",
        "data-color-one",
        "data-color-two",
        "data-color-three",
      ];
      attributesToRemove.forEach(attr => {
        activeNode.removeAttribute(attr);
      });

      setBucketColor1(
        changeBucketColorAccordingBackground([
          startColor === "transparent" ? startColor : hexToRGB(startColor),
          endColor === "transparent" ? endColor : hexToRGB(endColor),
        ])
      );
    }
  };

  const applyImage = (imgUrl, event, zoom) => {
    let activeNode = document.querySelector(".text-content");

    const val = parseFloat(zoom);
    const size = 50 + ((val - 1) / (5 - 1)) * 50; // map slider (1 → 5) → (50% → 100%)

    let cssstyle = {
      background: `url(${imgUrl})`,
      "background-repeat": "repeat",
      "background-size": `${size}% ${size}%`,
      "background-position": "center",
      "-webkit-text-fill-color": "transparent",
      "background-clip": "text",
      "-webkit-background-clip": "text",
      display: "inline-block",
      "font-family": activeNode.style.fontFamily,
      "font-size": activeNode.style.fontSize,
      "font-weight": activeNode.style.fontWeight,
      "letter-spacing": activeNode.style.letterSpacing ?? "0px",
    };

    // if outline apllied
    if (activeNode.getAttribute("data-outline")) {
      cssstyle = {
        ...cssstyle,
        "-webkit-text-stroke": `${activeNode.getAttribute("data-outline-width")}px ${activeNode.getAttribute(
          "data-outline-color"
        )}`,
      };
    }

    // Clear all inline styles
    activeNode.removeAttribute("style");

    // Apply new ones
    Object.entries(cssstyle).forEach(([prop, value]) => {
      activeNode.style.setProperty(prop, value);
    });

    // Add data attributes
    let data = {
      "data-fill-type": fillType,
      "data-image-url": imgUrl,
      "data-image-zoom": zoom,
    };
    Object.entries(data).forEach(([prop, value]) => {
      activeNode.setAttribute(prop, value);
    });

    // Remove some data attributes
    let attributesToRemove = [
      "data-color-one-range",
      "data-color-two-range",
      "data-color-three-range",
      "data-color-count",
      // "data-color-one",
      "data-color-two",
      "data-color-three",
      "data-grad-degree",
      "data-grad-scolor",
      "data-grad-spercen",
      "data-grad-ecolor",
      "data-grad-epercen",
    ];
    attributesToRemove.forEach(attr => {
      activeNode.removeAttribute(attr);
    });

    if (updateContext && event === "upload") {
      props.setTextHtml(document.querySelector(".text-content"));
    }
  };

  const fileSelectedHandler = e => {
    const file = e.target.files[0];

    let fileSize = file.size / 1e6;
    let fileFormat = file.type.split("/");
    let allowedImageTypes = ["jpeg", "jpg", "png", "webp"];
    let maxImageSize = 5; // in MB

    // upload image
    if (file && allowedImageTypes.includes(fileFormat[1]?.toLowerCase()) && fileSize <= maxImageSize) {
      setUploadAssetError({ status: false, message: "success" });
      setIsUploadDone(false);
      uploadImage(file);
    }
    // if file is large that max size
    else if (fileSize > maxImageSize) {
      e.target.value = ""; // cleaning the file upload field
      setUploadAssetError({
        status: true,
        message: `File Size should be maximum ${maxImageSize} MB.`,
      });
    }
    // if invalid format
    else {
      e.target.value = ""; // cleaning the file upload field
      setUploadAssetError({ status: true, message: "Invalid Format!!" });
    }

    setTimeout(function () {
      setUploadAssetError({ status: false, message: "" });
    }, 3000);
  };

  const uploadImage = file => {
    let formData = new FormData();
    formData.append("file", file, file.name);

    dispatch(uploadTextArtImage(formData, props.documentId)).then(r => {
      setIsUploadDone(true);
      setIamgeUrl(r.data.url);
      props.setImageId(r.data.id);
      applyImage(r.data.url, "upload", iamgeZoom);
    });
  };

  useEffect(() => {
    setFillType(document.querySelector(".text-content").getAttribute("data-fill-type") ?? "solid");
  }, []);

  useEffect(() => {
    // solid - type
    if (fillType === "solid") {
      setColorCount(
        document.querySelector(".text-content").getAttribute("data-color-count")
          ? parseInt(document.querySelector(".text-content").getAttribute("data-color-count"))
          : 1
      );
    }
    // gradient - type
    else if (fillType === "gradient") {
      setColorCount(0);
      if (!color1) setColor1(document.querySelector(".text-content").getAttribute("data-grad-scolor"));
      setColorPickerGradient(true);
      setIsGradientActive(true);
    }
    // image - type
    else if (fillType === "image") {
      let bgPicture = document.querySelector(".text-content").getAttribute("data-image-url") ?? default_config.image;
      let bgZoom = document.querySelector(".text-content").getAttribute("data-image-zoom")
        ? parseFloat(document.querySelector(".text-content").getAttribute("data-image-zoom"))
        : 1;

      setColorCount();
      applyImage(bgPicture, "load", bgZoom);
      setIamgeUrl(bgPicture);
      setIamgeZoom(bgZoom);
    }
  }, [fillType]);

  useEffect(() => {
    // if color 1 is set previously do not set again and apply color from here, if not set through color1 useeffect
    if (colorCount === 1 && !color1) {
      setColor1(document.querySelector(".text-content").getAttribute("data-color-one") ?? default_config.c1);
    } else if (colorCount !== undefined && colorCount <= 1) apllyColor();

    // if color 2 is set previously do not set again and range is set through color1Range useeffect
    if (colorCount === 2 && !color2) {
      if (!color1)
        setColor1(document.querySelector(".text-content").getAttribute("data-color-one") ?? default_config.c1);
      setColor2(document.querySelector(".text-content").getAttribute("data-color-two") ?? default_config.c2);
    }

    // if color 3 is set previously do not set again same for color2, and range is set through color1Range useeffect
    if (colorCount === 3 && !color3) {
      if (!color1)
        setColor1(document.querySelector(".text-content").getAttribute("data-color-one") ?? default_config.c1);
      if (!color2)
        setColor2(document.querySelector(".text-content").getAttribute("data-color-two") ?? default_config.c2);
      setColor3(document.querySelector(".text-content").getAttribute("data-color-three") ?? default_config.c3);
    }
  }, [colorCount]);

  useEffect(() => {
    if (fillType === "solid") {
      apllyColor(color1Range, color2Range);
      setBucketColor1(changeBucketColorAccordingBackground(hexToRGB(color1)));
    }
  }, [color1]);

  useEffect(() => {
    setColor1(bucketColor1EyeDropper);
  }, [bucketColor1EyeDropper]);

  useEffect(() => {
    !updateFromColorCountDropdown && apllyColor(color1Range, color2Range);
    setBucketColor2(changeBucketColorAccordingBackground(hexToRGB(color2)));
  }, [color2]);

  useEffect(() => {
    setColor2(bucketColor2EyeDropper);
  }, [bucketColor2EyeDropper]);

  useEffect(() => {
    !updateFromColorCountDropdown && apllyColor(color1Range, color2Range, color3Range);
    setBucketColor3(changeBucketColorAccordingBackground(hexToRGB(color3)));
  }, [color3]);

  useEffect(() => {
    setColor3(bucketColor3EyeDropper);
  }, [bucketColor3EyeDropper]);

  useEffect(() => {
    // for 3 color slider
    if (colorCount === 3) {
      // every time change color count from slider - default silder value will apply
      if (updateFromColorCountDropdown) {
        setColor1Range(default_config.r1);
        setColor2Range(default_config.r2);
        setColor3Range(default_config.r3);
        apllyColor(default_config.r1, default_config.r2, default_config.r3);
        return;
      }
      // else fetch previous one
      else {
        let c1range =
          color1Range ?? parseInt(document.querySelector(".text-content").getAttribute("data-color-one-range"));
        let c2range =
          color2Range ?? parseInt(document.querySelector(".text-content").getAttribute("data-color-two-range"));
        let c3range =
          color3Range ?? parseInt(document.querySelector(".text-content").getAttribute("data-color-three-range"));

        // Normal 3-slider sync
        const total = c1range + c2range + c3range;

        if (total !== 100) {
          const factor = 100 / total;
          const new1 = Math.round(c1range * factor);
          const new2 = Math.round(c2range * factor);
          const new3 = Math.round(c3range * factor);
          if (new1 !== c1range) setColor1Range(new1);
          if (new2 !== c2range) setColor2Range(new2);
          if (new3 !== c3range) setColor3Range(new3);
          apllyColor(new1, new2, new3);
        } else {
          setColor1Range(c1range);
          setColor2Range(c2range);
          setColor3Range(c3range);
          apllyColor(c1range, c2range, c3range);
        }
      }
    }
    // for 2 color slider
    else if (colorCount === 2) {
      // every time change color count from slider - default silder value will apply
      if (updateFromColorCountDropdown) {
        setColor1Range(50);
        setColor2Range(50);
        apllyColor(50, 50);
        return;
      }
      // else fetch previous one
      else {
        let c1range =
          color1Range ?? parseInt(document.querySelector(".text-content").getAttribute("data-color-one-range"));
        let c2range =
          color2Range ?? parseInt(document.querySelector(".text-content").getAttribute("data-color-two-range"));

        // Normal 2-slider sync
        const total = c1range + c2range;

        if (total !== 100) {
          const factor = 100 / total;
          const new1 = Math.round(c1range * factor);
          const new2 = Math.round(c2range * factor);
          if (new1 !== c1range) setColor1Range(new1);
          if (new2 !== c2range) setColor2Range(new2);
          apllyColor(new1, new2);
        } else {
          setColor1Range(c1range);
          setColor2Range(c2range);
          apllyColor(c1range, c2range);
        }
      }
    }
  }, [color1Range, color2Range, color3Range, colorCount]);

  useEffect(() => {
    if (fillType !== "image") apllyColor(color1Range, color2Range); // this useeffect is when change the silder for 2 or 3 color : it was not updated
  }, [updateContext]);

  useEffect(() => {
    if (colorPickerGradient && fillType === "gradient") {
      if (colorPickerGradient !== true) applyGradienColor();
    }
  }, [colorPickerGradient]);

  useEffect(() => {
    if (gradientHtml) props.setTextHtml(document.querySelector(".text-content"));
    setGradientHtml(false);
  }, [gradientHtml, colorPickerGradient]);

  useEffect(() => {
    if (iamgeZoom) {
      const text = document.querySelector(".text-content");
      const val = parseFloat(iamgeZoom);
      const size = 50 + ((val - 1) / (5 - 1)) * 50; // map slider (1 → 5) → (50% → 100%)
      text.style.backgroundSize = `${size}% ${size}%`;
      text.style.backgroundPosition = "center";
      text.setAttribute("data-image-zoom", iamgeZoom);
      updateContext && props.setTextHtml(document.querySelector(".text-content"));
    }
  }, [iamgeZoom, updateContext]);

  return (
    <>
      <div className={cx(style["d-flex"], style["radio-inline"], style["align-items-center"])}>
        {options.map((field, i) => (
          <div
            key={i}
            className={cx(style["custom-control"], style["custom-radio"], style["mb-2"], {
              [style["disable"]]:
                ["gradient", "image"].includes(field.value) &&
                document.querySelector(".text-content")?.getAttribute("data-transform-type") &&
                document.querySelector(".text-content")?.getAttribute("data-transform-type") !== "Path 1",
            })}>
            <RInput
              type="radio"
              id={field.value}
              name="textFillRadio"
              className={style["custom-control-input"]}
              checked={field.value === fillType}
              value={field.value}
              onChange={() => {
                props.setLoadCurrentFormating(false);
                setUpdateContext(true);
                setFillType(field.value);
              }}
            />
            <label className={style["custom-control-label"]} htmlFor={field.value}>
              {field.text}
            </label>
          </div>
        ))}
      </div>

      {fillType === "solid" && (
        <>
          {/* Dropdown color count */}
          <div className={cx(style["line-controls-wrap"], style["justify-content-start"], style["colors"])}>
            <div className={style["slidelabel"]}>Colors</div>
            <Dropdown
              isOpen={dropdownOpen}
              toggle={toggle2}
              className={cx(style["border-style"], {
                [style["disable"]]:
                  document.querySelector(".text-content")?.getAttribute("data-transform-type") &&
                  document.querySelector(".text-content")?.getAttribute("data-transform-type") !== "Path 1",
              })}>
              <DropdownToggle className={style["text-capitalize"]}>
                {colorCount}
                <Icon icon="ui-arrow-down" />
              </DropdownToggle>

              <DropdownMenu className={cx(style["shadow"], style["border-0"], style["rounded"])}>
                {solidColorCount.map(count => (
                  <React.Fragment key={count}>
                    <DropdownItem
                      className={cx(style["text-capitalize"], {
                        [style["active"]]: count === colorCount,
                      })}
                      tag="a"
                      onClick={() => {
                        props.setLoadCurrentFormating(false);
                        setUpdateContext(true);
                        setUpdateFromColorCountDropdown(true);
                        setColorCount(count);
                      }}>
                      {count}
                    </DropdownItem>
                  </React.Fragment>
                ))}
              </DropdownMenu>
            </Dropdown>
          </div>

          {/* color and Sliders */}
          <div className={cx(style["line-controls-wrap"], style["justify-content-start"], style["color-bucket"])}>
            <ColorBucket
              color={color1}
              setColor={setColor1}
              iconBucketColor={bucketColor1}
              position={"toolbar"}
              setLoadCurrentFormatting={props.setLoadCurrentFormating}
              setUpdateContext={setUpdateContext}
              eyedropperColor={bucketColor1EyeDropper}
              setEyedropperColor={setBucketColor1EyeDropper}
              className={"mr-2"}
            />
            {colorCount > 1 && (
              <SliderControll
                Slider={color1Range}
                setSlider={setColor1Range}
                sliderMin={0}
                sliderMax={100}
                sliderLabel={"Color %"}
                setUpdateContext={setUpdateContext}
                setLoadCurrentFormatting={props.setLoadCurrentFormating}
              />
            )}
          </div>
          {colorCount > 1 && (
            <div className={cx(style["line-controls-wrap"], style["justify-content-start"], style["color-bucket"])}>
              <ColorBucket
                color={color2}
                setColor={setColor2}
                iconBucketColor={bucketColor2}
                position={"toolbar"}
                setLoadCurrentFormatting={props.setLoadCurrentFormating}
                setUpdateContext={setUpdateContext}
                eyedropperColor={bucketColor2EyeDropper}
                setEyedropperColor={setBucketColor2EyeDropper}
              />
              <SliderControll
                Slider={color2Range}
                setSlider={setColor2Range}
                sliderMin={0}
                sliderMax={100}
                sliderLabel={"Color %"}
                setUpdateContext={setUpdateContext}
                setLoadCurrentFormatting={props.setLoadCurrentFormating}
              />
            </div>
          )}
          {colorCount > 2 && (
            <div className={cx(style["line-controls-wrap"], style["justify-content-start"], style["color-bucket"])}>
              <ColorBucket
                color={color3}
                setColor={setColor3}
                iconBucketColor={bucketColor3}
                position={"toolbar"}
                setLoadCurrentFormatting={props.setLoadCurrentFormating}
                setUpdateContext={setUpdateContext}
                eyedropperColor={bucketColor3EyeDropper}
                setEyedropperColor={setBucketColor3EyeDropper}
              />
              <SliderControll
                Slider={color3Range}
                setSlider={setColor3Range}
                sliderMin={0}
                sliderMax={100}
                sliderLabel={"Color %"}
                setUpdateContext={setUpdateContext}
                setLoadCurrentFormatting={props.setLoadCurrentFormating}
              />
            </div>
          )}
        </>
      )}

      {fillType === "gradient" && (
        <div className={cx(style["line-controls-wrap"], style["justify-content-start"], style["color-bucket"])}>
          <ColorBucket
            color={color1}
            setColor={setColor1}
            iconBucketColor={bucketColor1}
            position={"toolbar"}
            setLoadCurrentFormatting={props.setLoadCurrentFormating}
            setUpdateContext={setUpdateContext}
            eyedropperColor={bucketColor1EyeDropper}
            setEyedropperColor={setBucketColor1EyeDropper}
            colorPickerGradient={colorPickerGradient}
            setColorPickerGradient={setColorPickerGradient}
            isGradientActive={isGradientActive}
            setIsGradientActive={setIsGradientActive}
            source={"text-art"}
            setGradientHtml={setGradientHtml}
          />
        </div>
      )}

      {fillType === "image" && (
        <>
          <div className={cx(style["d-flex"], style["text-fill-image"])}>
            <div className={cx(style["mb-3"], style["upload-image-wrap"], style["mr-3"], style["flex-grow-1"])}>
              {/* upload button */}
              {(isUploadDone || isUploadDone === undefined) && (
                <div>
                  <div className={cx(style["fileUpload"], style["w-100"])}>
                    <input
                      type="file"
                      accept={"image/jpeg, image/png, image/webp"}
                      onChange={e => fileSelectedHandler(e)}
                    />
                    <span className={cx(style["btn"], style["btn-border"])}>
                      <Icon icon="ui-upload" /> Upload
                    </span>
                  </div>
                  <span className={style["info-text"]}>JPG, PNG, WebP: Up to 5 MB</span>
                </div>
              )}

              {/* Upload image Progressbar */}
              {isUploadDone === false && (
                <div className={cx(style["upload-loader"], style["text-center"])}>
                  <div className={style["download-progressbar"]}>
                    <ProgressLoader assetId={isUploadDone} />

                    <p className={style["upload-file-msg"]}>
                      <strong>Uploading File</strong>
                    </p>
                  </div>
                </div>
              )}
            </div>

            {/* uploaded image area */}
            <div className={style["img-preview"]}>
              <img src={iamgeUrl}></img>
            </div>
          </div>

          {/* Error messege area */}
          {uploadAssetError?.status && (
            <div id="uploadedImageErrorBox" className={cx(style["alert"], style["alert-block"], style["alert-danger"])}>
              {uploadAssetError.message}
            </div>
          )}

          {/* Zoom slider */}
          <div className={cx(style["line-controls-wrap"], style["justify-content-start"], style["image-zoom"])}>
            <SliderControll
              Slider={iamgeZoom}
              setSlider={setIamgeZoom}
              sliderMin={1}
              step={0.1}
              sliderMax={5}
              sliderLabel={"Image Zoom"}
              setUpdateContext={setUpdateContext}
              setLoadCurrentFormatting={props.setLoadCurrentFormating}
            />
          </div>
        </>
      )}
    </>
  );
};
TextFill.propTypes = {
  setTextHtml: PropTypes.func.isRequired,
  loadCurrentFormating: PropTypes.bool,
  setLoadCurrentFormating: PropTypes.func,
  setImageId: PropTypes.func,
  documentId: PropTypes.string,
};

const TextOutline = props => {
  const [isOutlineEnabled, setIsOutlineEnabled] = useState();
  const [outlineWidth, setOutlineWidth] = useState();
  const [outlineColor, setOutlineColor] = useState();
  const [iconBucketColor, setIconBucketColor] = useState();
  const [eyedropperColor, setEyedropperColor] = useState();
  const [updateContext, setUpdateContext] = useState();

  useEffect(() => {
    if (eyedropperColor) {
      setUpdateContext(true);
      setOutlineColor(eyedropperColor);
      setEyedropperColor();
    }
  }, [eyedropperColor]);

  useEffect(() => {
    if (isOutlineEnabled === undefined) return;

    //Remove outline property
    if (!isOutlineEnabled) {
      let el = document.querySelector(".text-content");

      // remove outline in path text
      if (
        el?.getAttribute("data-transform-type") &&
        ["Path 2", "Path 3", "Path 4", "Warp 9", "Warp 10"].includes(el?.getAttribute("data-transform-type"))
      ) {
        document.querySelector(".text-content svg text").removeAttribute("stroke");
        document.querySelector(".text-content svg text").removeAttribute("stroke-width");
      }
      // remove outline in warp text
      else if (
        el?.getAttribute("data-transform-type") &&
        ["Warp 1", "Warp 2", "Warp 3", "Warp 4", "Warp 5", "Warp 6", "Warp 7", "Warp 8"].includes(
          el?.getAttribute("data-transform-type")
        )
      ) {
        document.querySelector(".text-content svg path").removeAttribute("stroke");
        document.querySelector(".text-content svg path").removeAttribute("stroke-width");
      }
      // remove outline in normal text
      else {
        document.querySelector(".text-content").style.removeProperty("-webkit-text-stroke");
      }

      // Remove some data attributes
      let attributesToRemove = ["data-outline", "data-outline-color", "data-outline-width"];
      attributesToRemove.forEach(attr => {
        document.querySelector(".text-content").removeAttribute(attr);
      });
    }
    //Add outline property
    else {
      let color = outlineColor ?? props.textDefaultConfig.outlineColor;
      let width = outlineWidth ? parseInt(outlineWidth) : props.textDefaultConfig.outlineWidth;
      let el = document.querySelector(".text-content");

      // apply outline in path text
      if (
        el?.getAttribute("data-transform-type") &&
        ["Path 2", "Path 3", "Path 4", "Warp 9", "Warp 10"].includes(el?.getAttribute("data-transform-type"))
      ) {
        document.querySelector(".text-content svg text").setAttribute("stroke", color);
        document.querySelector(".text-content svg text").setAttribute("stroke-width", parseInt(width));
      }
      // apply outline in warp text
      else if (
        el?.getAttribute("data-transform-type") &&
        ["Warp 1", "Warp 2", "Warp 3", "Warp 4", "Warp 5", "Warp 6", "Warp 7", "Warp 8"].includes(
          el?.getAttribute("data-transform-type")
        )
      ) {
        document.querySelector(".text-content svg path").setAttribute("stroke", color);
        document.querySelector(".text-content svg path").setAttribute("stroke-width", parseInt(width));
      }
      // apply outline in normal text
      else {
        document.querySelector(".text-content").style.webkitTextStroke = `${width}px ${color}`;
      }

      // Add data attributes
      let data = {
        "data-outline": "on",
        "data-outline-color": color,
        "data-outline-width": width,
      };
      Object.entries(data).forEach(([prop, value]) => {
        document.querySelector(".text-content").setAttribute(prop, value);
      });

      // update bucket color
      color &&
        setIconBucketColor(changeBucketColorAccordingBackground(color !== "transparent" ? hexToRGB(color) : color));
    }

    updateContext && props.setTextHtml(document.querySelector(".text-content"));
  }, [isOutlineEnabled, outlineWidth, outlineColor, updateContext]);

  useEffect(() => {
    //Load Current Formatting :if outline previously applied
    if (document.querySelector(".text-content").getAttribute("data-outline")) {
      setOutlineWidth(parseInt(document.querySelector(".text-content").getAttribute("data-outline-width")));
      setOutlineColor(document.querySelector(".text-content").getAttribute("data-outline-color"));
      setIsOutlineEnabled(true);
    }
    // if outline previously not applied
    else {
      setIsOutlineEnabled(false);
    }
  }, []);

  const toggleOutline = () => {
    setUpdateContext(true);
    props.setLoadCurrentFormating(false);
    setIsOutlineEnabled(!isOutlineEnabled);

    if (!isOutlineEnabled) {
      setOutlineWidth(props.textDefaultConfig.outlineWidth);
      setOutlineColor(props.textDefaultConfig.outlineColor);
    }
  };

  return (
    <div>
      <div className={cx(style["custom-control"], style["custom-switch"], style["mb-3"])}>
        <RInput
          type="checkbox"
          className={style["custom-control-input"]}
          defaultChecked={isOutlineEnabled}
          id="customSwitchForOutline"
          value={isOutlineEnabled}
          onClick={toggleOutline}
        />

        <label className={style["custom-control-label"]} htmlFor="customSwitchForOutline">
          Outline
        </label>
      </div>

      {isOutlineEnabled && (
        <>
          <div className={cx(style["line-controls-wrap"], style["with-input"])}>
            <SliderControll
              Slider={outlineWidth}
              setSlider={setOutlineWidth}
              sliderMin={1}
              sliderMax={5}
              sliderLabel={"Outline Width"}
              setUpdateContext={setUpdateContext}
            />
          </div>

          <div className={cx(style["line-controls-wrap"], style["justify-content-start"])}>
            <div className={style["slidelabel"]}>Outline Color</div>
            <ColorBucket
              color={outlineColor}
              setColor={setOutlineColor}
              iconBucketColor={iconBucketColor}
              position={"toolbar"}
              setUpdateContext={setUpdateContext}
              eyedropperColor={eyedropperColor}
              setEyedropperColor={setEyedropperColor}
            />
          </div>
        </>
      )}
    </div>
  );
};
TextOutline.propTypes = {
  setTextHtml: PropTypes.func.isRequired,
  setLoadCurrentFormating: PropTypes.func,
  textDefaultConfig: PropTypes.obj,
};

const TextTransform = props => {
  const options = [
    {
      text: "Path",
      name: "path",
      value: "path",
    },
    {
      text: "Warp",
      name: "warp",
      value: "warp",
    },
  ];
  const warpObj = [
    { name: "Warp 1", sliderName: "Height", sliderMin: 20, sliderMax: 100, sliderDefault: 50, sliderStep: 1 },
    { name: "Warp 2", sliderName: "Height", sliderMin: 20, sliderMax: 100, sliderDefault: 50, sliderStep: 1 },
    { name: "Warp 3", sliderName: "Height", sliderMin: 20, sliderMax: 100, sliderDefault: 50, sliderStep: 1 },
    { name: "Warp 4", sliderName: "Height", sliderMin: 20, sliderMax: 100, sliderDefault: 50, sliderStep: 1 },
    { name: "Warp 5", sliderName: "Height", sliderMin: 20, sliderMax: 100, sliderDefault: 50, sliderStep: 1 },
    { name: "Warp 6", sliderName: "Height", sliderMin: 20, sliderMax: 100, sliderDefault: 50, sliderStep: 1 },
    { name: "Warp 7", sliderName: "Height", sliderMin: 20, sliderMax: 100, sliderDefault: 50, sliderStep: 1 },
    { name: "Warp 8", sliderName: "Height", sliderMin: 20, sliderMax: 100, sliderDefault: 50, sliderStep: 1 },
    { name: "Warp 9", sliderName: "Height", sliderMin: 20, sliderMax: 100, sliderDefault: 50, sliderStep: 1 },
    { name: "Warp 10", sliderName: "Height", sliderMin: 20, sliderMax: 100, sliderDefault: 50, sliderStep: 1 },
  ];
  const pathObj = { sliderName: "Curvature", sliderMin: 0, sliderMax: 300, sliderDefault: 0, sliderStep: 1 };

  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);

  const dispatch = useDispatch();
  const { textArtTransform } = useTextArtTransform();

  const [transformType, setTransformType] = useState();
  const [changeManual, setChangeManual] = useState();
  const [asstesLoading, setAsstesLoading] = useState();
  const [availableAssetLists, setAvailableAssetLists] = useState();
  const [tarnsformName, setTarnsformName] = useState();
  const [transformSliderValue, setTransformSliderValue] = useState();
  const [activeTransformObj, setActiveTransformObj] = useState();
  const [radiusValue, setRadiusValue] = useState();
  const [radiusMax, setRadiusMax] = useState();
  const [updateContext, setUpdateContext] = useState();
  const [swiperInstance, setSwiperInstance] = useState(null);
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  useEffect(() => {
    let transformValue = document.querySelector(".text-content")?.getAttribute("data-transform-type");

    if (transformValue) setTransformType(transformValue.split(" ")[0].toLocaleLowerCase());
    else setTransformType("path");
  }, []);

  useEffect(() => {
    if (transformType) {
      let payLoad = {
        assetType: "text_art",
        pageNumber: 1,
        limit: 50,
        assetCategory: transformType.charAt(0).toUpperCase() + transformType.slice(1),
      };

      setAsstesLoading(true);
      dispatch(filterAssetsList(payLoad)).then(r => {
        setAvailableAssetLists(r.data.data);
        setAsstesLoading(false);

        // set default one if manually change or there is no previous transform type
        if (changeManual || !document.querySelector(".text-content")?.getAttribute("data-transform-type")) {
          transformType === "path" ? setTarnsformName("Path 2") : setTarnsformName("Warp 1");
        }
        // load exsisting
        else {
          setTarnsformName(document.querySelector(".text-content")?.getAttribute("data-transform-type"));
        }
      });
    }
  }, [transformType]);

  useEffect(() => {
    const currentObj = warpObj.find(item => item.name === tarnsformName);
    // if transformType warp : set slider value
    if (currentObj) {
      setRadiusValue();
      setActiveTransformObj(currentObj);
      setTransformSliderValue(
        document.querySelector(".text-content")?.getAttribute("data-transform-value")
          ? parseInt(document.querySelector(".text-content")?.getAttribute("data-transform-value"))
          : currentObj.sliderDefault
      );
    }
    // else transformType path
    else {
      setActiveTransformObj();

      // call the hook switch function
      if (tarnsformName === "Path 1") {
        setRadiusValue();
        setUpdateContext(true);
        if (!props.loadCurrentFormating)
          textArtTransform(tarnsformName, false, updateContext, props.setTextHtml, props.setLetterSpacing);
        props.fitTextToContainer(".TMright-pane", ".text-content");
      }
      // set radius slider value
      else if (tarnsformName !== undefined) {
        setRadiusMax(100); // always show 0–100 slider
        const savedRealValue =
          parseFloat(document.querySelector(".text-content")?.getAttribute("data-radius-value")) || 0;
        setRadiusValue(savedRealValue);
      }
    }
  }, [tarnsformName]);

  useEffect(() => {
    if (radiusValue !== undefined && tarnsformName) {
      textArtTransform(tarnsformName, radiusValue, updateContext, props.setTextHtml, props.setLetterSpacing);
    }
  }, [radiusValue, updateContext]);

  useEffect(() => {
    if (transformSliderValue && !props.loadCurrentFormating) {
      textArtTransform(
        tarnsformName,
        transformSliderValue,
        updateContext,
        props.setTextHtml,
        false,
        props.availableFontLists
      );
    }
  }, [transformSliderValue, updateContext]);

  useEffect(() => {
    if (!swiperInstance) return;
    if (!navigationPrevRef.current || !navigationNextRef.current) return;

    swiperInstance.params.navigation.prevEl = navigationPrevRef.current;
    swiperInstance.params.navigation.nextEl = navigationNextRef.current;

    if (swiperInstance.navigation) {
      swiperInstance.navigation.destroy();
    }
    swiperInstance.navigation = new SwiperCore.Navigation(swiperInstance);
    try {
      swiperInstance.navigation.init();
      swiperInstance.navigation.update();
    } catch (err) {
      if (swiperInstance.navigation && typeof swiperInstance.navigation.init === "function") {
        swiperInstance.navigation.init();
        swiperInstance.navigation.update();
      }
    }
  }, [swiperInstance, navigationPrevRef.current, navigationNextRef.current]);

  useEffect(() => {
    // set all transform related states after udeo redo
    if (props.changeTransformTypeOnUndo && props.changeTransformCatgoryOnUndo) {
      setChangeManual(false);
      setTransformType(props.changeTransformCatgoryOnUndo.toLocaleLowerCase());
      setTarnsformName(props.changeTransformTypeOnUndo);
      if (props.changeTransformCatgoryOnUndo === "Warp")
        setTransformSliderValue(
          parseInt(document.querySelector(".text-content")?.getAttribute("data-transform-value"))
        );
    }
  }, [props.changeTransformTypeOnUndo, props.changeTransformCatgoryOnUndo]);

  return (
    <>
      <div className={cx(style["d-flex"], style["radio-inline"], style["align-items-center"])}>
        {options.map((field, i) => (
          <div key={i} className={cx(style["custom-control"], style["custom-radio"], style["mb-2"])}>
            <RInput
              type="radio"
              id={field.value}
              name="textFillRadio"
              className={style["custom-control-input"]}
              checked={field.value === transformType}
              value={field.value}
              onChange={() => {
                props.setLoadCurrentFormating(false);
                setUpdateContext(true);
                setChangeManual(true);
                setTransformSliderValue();
                setTransformType(field.value);
              }}
            />
            <label className={style["custom-control-label"]} htmlFor={field.value}>
              {field.text}
            </label>
          </div>
        ))}
      </div>

      <div className={style["carousel-container"]}>
        {/* Loader */}
        {asstesLoading && (
          <ul className={style["path-warp-assets"]}>
            <AssetsLoader count={4} />
          </ul>
        )}

        {availableAssetLists?.length > 0 && !asstesLoading && (
          <div
            className={cx(style["swiper-container"], style["overflow-visible"], {
              [style["path"]]: transformType === "path",
            })}>
            <Swiper
              lazy={true}
              navigation={{
                prevEl: "swiper-button-prev",
                nextEl: "swiper-button-next",
              }}
              onSwiper={swiper => {
                setTimeout(() => {
                  swiper.params.navigation.prevEl = navigationPrevRef.current;
                  swiper.params.navigation.nextEl = navigationNextRef.current;

                  swiper.navigation.init();
                  swiper.navigation.update();
                });
                if (transformType !== "path") {
                  setIsBeginning(swiper.isBeginning);
                  setIsEnd(false);
                }
              }}
              onSlideChange={swiper => {
                if (transformType !== "path") {
                  setIsBeginning(swiper.isBeginning);
                  setIsEnd(swiper.isEnd);
                }
              }}
              modules={[Navigation]}
              autoplay={false}
              spaceBetween={16}
              slidesPerView={4}
              loop={false}>
              {availableAssetLists?.length > 0 &&
                !asstesLoading &&
                availableAssetLists.map((availableAssetList, index) => (
                  <SwiperSlide key={availableAssetList?._id}>
                    <div
                      id={`asset-image-${index}`}
                      className={cx(style["asset-item"], {
                        [style["active"]]: availableAssetList?.name === tarnsformName,
                      })}
                      style={{ minWidth: "89px", minHeight: "89px" }}
                      onClick={() => {
                        props.setLoadCurrentFormating(false);
                        setTransformSliderValue();
                        setRadiusValue();
                        setTarnsformName(availableAssetList?.name);
                      }}>
                      <div className={style["item-holder"]}>
                        <img src={availableAssetList?.thumb} className={cx(style["icon"])} />
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
            </Swiper>

            <>
              <button
                ref={navigationPrevRef}
                className={cx(style["swiper-button-prev"], { [style["disabled"]]: isBeginning })}
                style={{
                  visibility:
                    availableAssetLists?.length > 0 && !asstesLoading && transformType !== "path"
                      ? "visible"
                      : "hidden",
                }}
                aria-label="prev">
                <Icon icon="ui-arrow-left" />
              </button>
              <button
                ref={navigationNextRef}
                className={cx(style["swiper-button-next"], { [style["disabled"]]: isEnd })}
                style={{
                  visibility:
                    availableAssetLists?.length > 0 && !asstesLoading && transformType !== "path"
                      ? "visible"
                      : "hidden",
                }}
                aria-label="next">
                <Icon icon="ui-arrow-right" />
              </button>
            </>
          </div>
        )}
      </div>

      {activeTransformObj && availableAssetLists?.length > 0 && !asstesLoading && (
        <div className={cx(style["line-controls-wrap"], style["transform-height"])}>
          <SliderControll
            Slider={transformSliderValue}
            setSlider={setTransformSliderValue}
            sliderMin={activeTransformObj.sliderMin}
            sliderMax={activeTransformObj.sliderMax}
            sliderLabel={activeTransformObj.sliderName}
            step={activeTransformObj.sliderStep}
            setUpdateContext={setUpdateContext}
            setLoadCurrentFormating={props.setLoadCurrentFormating}
          />
        </div>
      )}

      {["Path 2", "Path 3", "Path 4"].includes(tarnsformName) && availableAssetLists?.length > 0 && !asstesLoading && (
        <div className={cx(style["line-controls-wrap"], style["path-radius"])}>
          <SliderControll
            Slider={radiusValue}
            setSlider={setRadiusValue}
            sliderMin={0}
            sliderMax={radiusMax}
            sliderLabel={pathObj.sliderName}
            step={pathObj.sliderStep}
            setUpdateContext={setUpdateContext}
            setLoadCurrentFormating={props.setLoadCurrentFormating}
          />
        </div>
      )}
    </>
  );
};
TextTransform.propTypes = {
  setTextHtml: PropTypes.func.isRequired,
  loadCurrentFormating: PropTypes.bool,
  setLoadCurrentFormating: PropTypes.func,
  textContent: PropTypes.string,
  setLetterSpacing: PropTypes.func,
  changeTransformTypeOnUndo: PropTypes.string,
  changeTransformCatgoryOnUndo: PropTypes.string,
  availableFontLists: PropTypes.obj,
  fitTextToContainer: PropTypes.func,
};

const TextArt = props => {
  const textDefaultConfig = {
    textContent: "STYLE YOUR TEXT",
    fontFamily: "Poppins",
    fontSize: "76.1338px",
    fontWeight: "700",
    fontColor: "#72ac4d",
    outlineColor: "#000000",
    outlineWidth: 2,
  };
  const availableFonts = JSON.parse(localStorage?.getItem("allFonts"));

  const documentId = useSelector(state => state.document?.documentDetails?.data?.id);
  const customFonts = useSelector(state => state?.resources?.custom_fonts?.all?.fonts);

  let { metadata, widgets, updateWidgets } = useContext(EditorContext);

  const [textHtml, setTextHtml] = useState();
  const [textContent, setTextContent] = useState();
  const [charCount, setCharCount] = useState(0);
  const [textFontFamily, setTextFontFamily] = useState();
  const [textBold, setTextBold] = useState();
  const [isBoldDisable, setIsBoldDisable] = useState();
  const [letterSpacing, setLetterSpacing] = useState();
  const [updateSpacingContext, setUpdateSpacingContext] = useState(false);
  const [loadCurrentFormating, setLoadCurrentFormating] = useState(true);
  const [activeTab, setActiveTab] = useState();
  const [imageId, setImageId] = useState();
  const [assetInnerContent, setAssetInnerContent] = useState();
  const [widgetWidth, setWidgetWidth] = useState();
  const [widgetHeight, setWidgetHeight] = useState();
  const [addWidgetClicked, setAddWidgetClicked] = useState(false);
  const [dataparam, setDataParam] = useState();
  const [history, setHistory] = useState([]);
  const [pointer, setPointer] = useState(-1);
  const [changeTransformTypeOnUndo, setChangeTransformTypeOnUndo] = useState();
  const [changeTransformCatgoryOnUndo, setChangeTransformCatgoryOnUndo] = useState();
  const [availableFontLists, setAvailableFontLists] = useState();

  const skipHistory = useRef(false);
  const dispatch = useDispatch();
  const { postion: getPosition } = useAlignment(addWidgetClicked, widgetWidth, widgetHeight, "middle-center");
  const getNewWidgetObject = useAddWidget(
    addWidgetClicked,
    TEXT_ART,
    dataparam,
    getPosition,
    widgetWidth,
    widgetHeight
  );
  useElementInnerHtml(
    addWidgetClicked,
    setAddWidgetClicked,
    TEXT_ART,
    assetInnerContent,
    dataparam,
    getNewWidgetObject
  );
  const { textArtTransform } = useTextArtTransform();

  useEffect(() => {
    // font api call
    let payLoad = {
      assetType: "text_art_fonts",
      pageNumber: 1,
      limit: 500,
    };
    dispatch(fetchAssetsList(payLoad)).then(r => {
      const mergedArray = [...customFonts, ...r.data.data.value];
      setAvailableFontLists(mergedArray);
    });

    // for Add New
    if (!props.editable) {
      let elem = document.createElement("div");
      elem.classList.add("text-content");
      elem.style.fontFamily = textDefaultConfig.fontFamily;
      elem.style.fontSize = textDefaultConfig.fontSize;
      elem.style.fontWeight = textDefaultConfig.fontWeight;
      elem.style.color = textDefaultConfig.fontColor;
      elem.style.webkitTextStroke = `${textDefaultConfig.outlineWidth}px ${textDefaultConfig.outlineColor}`;
      elem.innerText = textDefaultConfig.textContent;

      elem.setAttribute("data-content", textDefaultConfig.textContent);
      elem.setAttribute("data-outline", "on");
      elem.setAttribute("data-outline-color", textDefaultConfig.outlineColor);
      elem.setAttribute("data-outline-width", textDefaultConfig.outlineWidth);

      setLoadCurrentFormating(true);
      setActiveTab(0);
      setTextContent(textDefaultConfig.textContent);
      setCharCount(textDefaultConfig.textContent.trim().length);
      setTextFontFamily(textDefaultConfig.fontFamily);
      setTextBold(true);
      setLetterSpacing(0);
      setTextHtml(elem);
    }
    // for update exsisting one
    else {
      let element = props.editable.querySelector(".text-content-editor").cloneNode(true);
      element.classList.add("text-content");
      element.classList.remove("text-content-editor");

      if (!element.getAttribute("data-transform-type") || element.getAttribute("data-transform-type") === "Path 1") {
        element.style.visibility = "hidden";
        document.querySelector(".TMright-pane").appendChild(element);
        fitTextToContainer(".TMright-pane", ".text-content");
      }

      // when edit warp text - in modal it is coming big (as at time of insertion svg was trimmed, viewbox was manupulated)
      if (element.getAttribute("data-transform-value") && element.getAttribute("data-viewBox-value")) {
        element.querySelector("svg").setAttribute("width", 500);
        element.querySelector("svg").setAttribute("height", 300);
        element.querySelector("svg").setAttribute("viewBox", element.getAttribute("data-viewBox-value"));
      }

      if (["Path 3", "Path 4"].includes(element.getAttribute("data-transform-type")))
        element.querySelector("svg").style.maxWidth = `${element.getAttribute("data-max-width")}px`;

      setLoadCurrentFormating(true);
      setActiveTab(
        element.getAttribute("data-transform-type") && element.getAttribute("data-transform-type") !== "Path 1" ? 2 : 0
      );
      setTextContent(element.getAttribute("data-content"));
      setCharCount(element.getAttribute("data-content").trim().length);
      setTextFontFamily(element.style.fontFamily.replace(/^["']|["']$/g, ""));
      setTextBold(parseInt(element.style.fontWeight) === 700 ? true : false);
      setLetterSpacing(parseInt(element.style.letterSpacing));
      setTextHtml(element);

      // remove phedo elem if present
      const hasChildWithClass =
        document.querySelector(".TMright-pane").querySelectorAll(":scope > .text-content").length > 0;
      if (hasChildWithClass)
        document.querySelector(".TMright-pane").removeChild(document.querySelector(".text-content"));
    }
  }, []);

  useEffect(() => {
    if (textFontFamily) updateFontFamily();
  }, [textFontFamily]);

  useEffect(() => {
    updateSpacing();
  }, [letterSpacing, updateSpacingContext]);

  useEffect(() => {
    if (
      textContent &&
      document.querySelector(".text-content").getAttribute("data-transform-type") &&
      document.querySelector(".text-content").getAttribute("data-transform-type") !== "Path 1" &&
      !loadCurrentFormating
    ) {
      if (document.querySelector(".text-content").getAttribute("data-transform-value"))
        textArtTransform(
          document.querySelector(".text-content").getAttribute("data-transform-type"),
          parseInt(document.querySelector(".text-content").getAttribute("data-transform-value")),
          true,
          setTextHtml,
          false,
          availableFontLists
        );
      else
        textArtTransform(
          document.querySelector(".text-content").getAttribute("data-transform-type"),
          parseInt(document.querySelector(".text-content").getAttribute("data-radius-value")) ?? 0,
          true,
          setTextHtml,
          setLetterSpacing
        );
    }
  }, [textContent, textFontFamily, textBold]);

  useEffect(() => {
    if (textHtml) {
      if (skipHistory.current) {
        skipHistory.current = false; // reset for next time
        return;
      }
      const slicedHistory = history.length > 0 ? history.slice(0, pointer + 1) : [];
      setHistory([...slicedHistory, textHtml]);
      setPointer(slicedHistory.length); // new index at the end
    }
  }, [textHtml]);

  const updateTextContent = (value, eventTigger) => {
    // for transform applied text do not update html from here
    if (
      !document.querySelector(".text-content").getAttribute("data-transform-type") ||
      document.querySelector(".text-content").getAttribute("data-transform-type") === "Path 1"
    )
      document.querySelector(".text-content").innerText = value;

    // fit on right pane
    if (
      !document.querySelector(".text-content").getAttribute("data-transform-type") ||
      document.querySelector(".text-content").getAttribute("data-transform-type") === "Path 1"
    )
      fitTextToContainer(".TMright-pane", ".text-content");

    setTextContent(value);
    setCharCount(value.trim().length);
    document.querySelector(".text-content").setAttribute("data-content", value);

    // for transform applied text do not update html from here
    if (
      eventTigger &&
      (!document.querySelector(".text-content").getAttribute("data-transform-type") ||
        document.querySelector(".text-content").getAttribute("data-transform-type") === "Path 1")
    ) {
      setTextHtml(document.querySelector(".text-content"));
    }
  };

  const updateFontFamily = () => {
    if (document.querySelector(".text-content")) {
      // update font family
      document.querySelector(".text-content").style.fontFamily = textFontFamily;

      // fit on right pane
      if (
        !document.querySelector(".text-content").getAttribute("data-transform-type") ||
        document.querySelector(".text-content").getAttribute("data-transform-type") === "Path 1"
      )
        fitTextToContainer(".TMright-pane", ".text-content");

      // update bold status according that font family
      let index = availableFonts.findIndex(
        font => font.name.toLowerCase() === textFontFamily.replace(/["]+/g, "").toLowerCase()
      );
      if (availableFonts[index]?.bold_weight === "") {
        setIsBoldDisable(true);
        if (document.querySelector(".text-content").style.fontWeight === "700") {
          let normalWiight = parseInt(availableFonts[index].normal_weight);
          document.querySelector(".text-content").style.fontWeight = normalWiight;
          setTextBold(false);
        }
      } else setIsBoldDisable(false);

      // update html
      if (!loadCurrentFormating) setTextHtml(document.querySelector(".text-content"));
    }
  };

  const handleBold = () => {
    if (document.querySelector(".text-content")) {
      let currentFontFamily = document.querySelector(".text-content").style.fontFamily;
      let index = availableFonts.findIndex(
        font => font.name.toLowerCase() === currentFontFamily.replace(/["]+/g, "").toLowerCase()
      );
      let normalWiight = parseInt(availableFonts[index].normal_weight);
      let currentWeight = parseInt(document.querySelector(".text-content").style.fontWeight);

      document.querySelector(".text-content").style.fontWeight = currentWeight === 700 ? normalWiight : 700;

      // fit on right pane
      if (
        !document.querySelector(".text-content").getAttribute("data-transform-type") ||
        document.querySelector(".text-content").getAttribute("data-transform-type") === "Path 1"
      )
        fitTextToContainer(".TMright-pane", ".text-content");

      setTextBold(currentWeight === 700 ? false : true);
      setTextHtml(document.querySelector(".text-content"));
    }
  };

  const updateSpacing = () => {
    if (document.querySelector(".text-content")) {
      document.querySelector(".text-content").style.letterSpacing = `${letterSpacing}px`;
      document.querySelector(".text-content").style.whiteSpace = "nowrap";
      fitTextToContainer(".TMright-pane", ".text-content");
    }

    if (updateSpacingContext && !loadCurrentFormating) {
      setTextHtml(document.querySelector(".text-content"));
    }

    setUpdateSpacingContext(false);
  };

  const fitTextToContainer = (containerSel, textSel, opts = {}) => {
    if (
      document.querySelector(".text-content").getAttribute("data-transform-type") &&
      document.querySelector(".text-content").getAttribute("data-transform-type") !== "Path 1"
    )
      return;

    const container = typeof containerSel === "string" ? document.querySelector(containerSel) : containerSel;
    const textEl = typeof textSel === "string" ? document.querySelector(textSel) : textSel;
    if (!container || !textEl) return;

    const csContainer = window.getComputedStyle(container);
    const padLeft = parseFloat(csContainer.paddingLeft) || 0;
    const padRight = parseFloat(csContainer.paddingRight) || 0;
    const padTop = parseFloat(csContainer.paddingTop) || 0;
    const padBottom = parseFloat(csContainer.paddingBottom) || 0;
    const borderL = parseFloat(csContainer.borderLeftWidth) || 0;
    const borderR = parseFloat(csContainer.borderRightWidth) || 0;
    const borderT = parseFloat(csContainer.borderTopWidth) || 0;
    const borderB = parseFloat(csContainer.borderBottomWidth) || 0;
    const tolerance = typeof opts.tolerance === "number" ? opts.tolerance : 1;

    // ✅ new: optional padding value (e.g., "1rem", "10px", 12)
    const extraPaddingPx = (() => {
      const pad = "20px";
      if (typeof pad === "number") return pad; // direct px number
      if (typeof pad === "string") {
        const el = document.createElement("div");
        el.style.width = pad;
        document.body.appendChild(el);
        const px = parseFloat(window.getComputedStyle(el).width);
        document.body.removeChild(el);
        return px;
      }
      return 0;
    })();

    textEl.style.whiteSpace = "nowrap";
    textEl.style.display = "block";
    // textEl.style.display = "inline-block";

    const run = () => {
      const containerRect = container.getBoundingClientRect();
      const availableW = Math.max(
        0,
        containerRect.width - padLeft - padRight - borderL - borderR - tolerance - extraPaddingPx * 2
      );
      const availableH = Math.max(
        0,
        containerRect.height - padTop - padBottom - borderT - borderB - tolerance - extraPaddingPx * 2
      );

      const csText = window.getComputedStyle(textEl);
      const currentFont = parseFloat(csText.fontSize) || 100;
      const minFont = typeof opts.minFont === "number" ? opts.minFont : 6;
      const maxFont = 100; // <- fixed max font size

      if (!availableW || !availableH || textEl.textContent.trim() === "") return;

      let low = minFont;
      let high = maxFont;
      let best = low;

      while (high - low > 0.25) {
        const mid = (low + high) / 2;
        textEl.style.fontSize = mid + "px";

        const textRect = textEl.getBoundingClientRect();
        const textW = textRect.width;
        const textH = textRect.height;

        if (textW <= availableW && textH <= availableH) {
          best = mid;
          low = mid;
        } else {
          high = mid;
        }
      }

      textEl.style.fontSize = Math.max(minFont, best) + "px";
    };

    if (document.fonts && document.fonts.status !== "loaded") {
      document.fonts.ready.then(run).catch(run);
    } else {
      run();
    }

    return run;
  };

  const trimSVG = svg => {
    const bbox = svg.getBBox();
    const { x, y, width, height } = bbox;

    svg.setAttribute("viewBox", `${x} ${y} ${width} ${height + 2}`);
    svg.setAttribute("width", width);
    svg.setAttribute("height", height + 2);
    svg.style.width = "100%";
    svg.style.height = "100%";

    if (["Path 3", "Path 4"].includes(document.querySelector(".text-content").getAttribute("data-transform-type")))
      svg.style.maxWidth = "";

    setWidgetWidth(width);
    setWidgetHeight(height + 2);
  };

  const insertTextFrame = () => {
    const original = document.querySelector(".text-content");
    const clone = original.cloneNode(true);
    clone.style.visibility = "hidden";
    document.querySelector("body").appendChild(clone);

    if (original.getAttribute("data-transform-type") && original.getAttribute("data-transform-type") !== "Path 1")
      trimSVG(clone.querySelector("svg"));
    else {
      setWidgetWidth(original.offsetWidth + 2);
      setWidgetHeight(original.offsetHeight);

      if (original.getAttribute("data-fill-type") === "image" && imageId) {
        dispatch(insertTextArtImage(imageId, documentId));
      }
    }

    let dataAttr = { ...widgetConfig[TEXT_ART].dataAttr };
    clone.classList.remove("text-content");
    clone.classList.add("text-content-editor");
    clone.style.visibility = "visible";
    let innerContent = clone.outerHTML;

    setAssetInnerContent(innerContent);
    setDataParam(dataAttr);
    setAddWidgetClicked(true);

    setTimeout(() => {
      clone.remove();
      props.closeModal();
      props.setModalFullScreen(false);
    }, 300);
  };

  const updateTextFrame = () => {
    const modal = document.querySelector(".text-content");
    const editor = document.querySelector(`#${metadata.activeWidgetId[0]} .text-content-editor`);

    let width, height;
    modal.style.visibility = "hidden";

    // upadte for warp and path text
    if (modal.getAttribute("data-transform-type") && modal.getAttribute("data-transform-type") !== "Path 1") {
      trimSVG(document.querySelector(".text-content svg"));

      // if transform type is not same as previous or if warp text and content is not same or slider value is not same - caluculate new width height
      if (
        modal.getAttribute("data-transform-type") !== editor.getAttribute("data-transform-type") ||
        (modal.getAttribute("data-transform-value") &&
          (modal.getAttribute("data-content") !== editor.getAttribute("data-content") ||
            modal.getAttribute("data-transform-value") !== editor.getAttribute("data-transform-value")))
      ) {
        width = document.querySelector(".text-content svg").getAttribute("width");
        height = document.querySelector(".text-content svg").getAttribute("height");
      }
      // else previous width height
      else {
        width = parseFloat(document.getElementById(metadata.activeWidgetId[0]).style.width);
        height = parseFloat(document.getElementById(metadata.activeWidgetId[0]).style.height);
      }
    }
    // upadte for normal text
    else {
      // if transform type is not same as previous or text content, font family, bold spacing are not same - caluculate new width height
      if (
        modal.getAttribute("data-transform-type") !== editor.getAttribute("data-transform-type") ||
        modal.getAttribute("data-content") !== editor.getAttribute("data-content") ||
        modal.style.fontFamily !== editor.style.fontFamily ||
        modal.style.fontWeight !== editor.style.fontWeight ||
        modal.style.letterSpacing !== editor.style.letterSpacing
      ) {
        width = modal.offsetWidth + 2;
        height = modal.offsetHeight;
      }
      // else previous width height
      else {
        modal.style.fontSize = editor.style.fontSize;

        width = parseFloat(document.getElementById(metadata.activeWidgetId[0]).style.width);
        height = parseFloat(document.getElementById(metadata.activeWidgetId[0]).style.height);
      }

      if (modal.getAttribute("data-fill-type") === "image" && imageId) {
        dispatch(insertTextArtImage(imageId, documentId));
      }
    }

    let clone = modal.cloneNode(true);
    clone.style.visibility = "visible";
    clone.classList.remove("text-content");
    clone.classList.add("text-content-editor");
    let innerContent = clone.outerHTML;

    document.querySelector(`#${metadata.activeWidgetId[0]} .dhp-widget-inner`).innerHTML = innerContent;

    // update context
    let targetWidgetIndex = widgets.findIndex(widget => widget.id === metadata.activeWidgetId[0]);
    let newArray = Object.assign([...widgets], {
      [targetWidgetIndex]: {
        ...widgets[targetWidgetIndex],
        style: {
          ...widgets[targetWidgetIndex].style,
          height: `${height}px`,
          width: `${width}px`,
        },
        innerHTML: document.getElementById(metadata.activeWidgetId[0]).innerHTML,
      },
    });

    updateWidgets(newArray);

    setTimeout(() => {
      // clone.remove();
      props.closeModal();
      props.setModalFullScreen(false);
    }, 300);
  };

  const undo = () => {
    if (pointer > 0) {
      const newPointer = pointer - 1;
      skipHistory.current = true; // prevent recording
      setPointer(newPointer);
      setTextHtml(history[newPointer]);
      if (activeTab !== 2) setActiveTab();
      setTimeout(() => {
        updateStateAfterUndoRedo();
      }, 100);
    }
  };

  const redo = () => {
    if (pointer < history.length - 1) {
      const newPointer = pointer + 1;
      skipHistory.current = true; // prevent recording
      setPointer(newPointer);
      setTextHtml(history[newPointer]);
      if (activeTab !== 2) setActiveTab();
      setTimeout(() => {
        updateStateAfterUndoRedo();
      }, 100);
    }
  };

  const updateStateAfterUndoRedo = () => {
    let element = document.querySelector(".text-content");

    setLoadCurrentFormating(true);

    if (activeTab === 2) {
      if (!document.querySelector(".text-content").getAttribute("data-transform-type")) setActiveTab(0);
      if (!document.querySelector(".text-content").getAttribute("data-transform-value"))
        setChangeTransformCatgoryOnUndo("Path");
      else setChangeTransformCatgoryOnUndo("Warp");
      setChangeTransformTypeOnUndo(document.querySelector(".text-content").getAttribute("data-transform-type"));
    } else if (activeTab !== 2) setActiveTab(activeTab);

    setTextContent(element.getAttribute("data-content"));
    setCharCount(element.getAttribute("data-content").trim().length);
    setTextFontFamily(element.style.fontFamily);
    setTextBold(parseInt(element.style.fontWeight) === 700 ? true : false);
    setLetterSpacing(element.style.letterSpacing ? parseInt(element.style.letterSpacing) : 0);
  };

  return (
    <div className={cx(style["text-art-modal-wrap"], style["table-modal-wrap"])} id="text-art-modal">
      <div className={cx(style["d-flex"], style["justify-content-between"], style["modal-header"])}>
        <h4 className={cx(style["fw-7"], style["mb-0"])}>Text Art</h4>

        <div>
          <ul className={cx(style["undo-redo-area"])}>
            <li className={cx(style["custom-tooltip"], { [style["disable"]]: pointer === 0 })}>
              <span className={cx(style["cursor-pointer"], style["d-flex"])} onClick={() => undo()}>
                <Icon icon="ui-undo" />
              </span>
              <div className={cx(style["custom-tooltip-content"], style["bottom"], style["mt-5"])}>Undo</div>
            </li>
            <li className={cx(style["custom-tooltip"], { [style["disable"]]: pointer === history.length - 1 })}>
              <span className={cx(style["cursor-pointer"], style["d-flex"])} onClick={() => redo()}>
                <Icon icon="ui-redo" />
              </span>
              <div className={cx(style["custom-tooltip-content"], style["bottom"], style["mt-5"])}>Redo</div>
            </li>
          </ul>
          <span
            className={cx(style["expand-btn"], style["rounded"])}
            onClick={() => props.setModalFullScreen(!props.modalFullScreen)}>
            <Icon icon={props.modalFullScreen ? "ui-collapse" : "ui-expand"} />
          </span>
          <span
            className={cx(style["cross-modal"], style["rounded"])}
            onClick={() => {
              props.closeModal(), props.setModalFullScreen(false);
            }}>
            <Icon icon="ui-close" />
          </span>
        </div>
      </div>

      <Row className={cx(style["table-modal-tab"], style["map-modal-tab"], style["m-0"])}>
        {/* Left Side Column*/}
        <Col xs={5} className={cx(style["TMleft-pane"], style["pt-3"])}>
          <div>
            {/* className={cx(style["customScroll"], style["scroll-Y"])} */}
            {/* Input TEXT */}
            <div className={style["text-input"]}>
              <Input
                label="Your Text"
                type="text"
                name="nameTextField"
                value={textContent}
                maxLength={25}
                onChange={e => {
                  setLoadCurrentFormating(false);
                  updateTextContent(e.target.value, true);
                }}
                required={true}
                autoFocus
              />
              <div
                className={cx(style["d-flex"], style["justify-content-end"], style["mt-1"])}>{`${charCount}/25`}</div>
            </div>
            {/* Text Styling */}
            <ul className={cx(style["font-style"], style["mb-3"])}>
              <FontFamily
                defaultFontSet={textFontFamily}
                setFontFamily={setTextFontFamily}
                sourceComponent={TEXT_ART}
                setLoadCurrentFormating={setLoadCurrentFormating}
              />

              <li
                className={cx(
                  style["wh-40"],
                  style["toolset-group"],
                  {
                    [style["active"]]: textBold,
                  },
                  {
                    [style["disabled"]]: isBoldDisable,
                  }
                )}>
                <div className={cx(style["toolset-item"], style["bold-wrap"])} id="bold-wrap">
                  <span
                    className={cx(style["toolset-action"], style["custom-tooltip"])}
                    onClick={() => {
                      setLoadCurrentFormating(false);
                      handleBold();
                    }}>
                    <Icon icon="bold2" />
                    <div className={cx(style["custom-tooltip-content"], style["top"])}>Bold</div>
                  </span>
                </div>
              </li>

              <li
                className={cx(style["wh-40"], style["toolset-group"], {
                  [style["disable"]]:
                    document.querySelector(".text-content")?.getAttribute("data-transform-type") &&
                    document.querySelector(".text-content")?.getAttribute("data-transform-type") !== "Path 1",
                })}>
                <UncontrolledDropdown setActiveFromChild className={cx(style["toolset-item"], style["spacing-wrap"])}>
                  <DropdownToggle
                    tag="span"
                    className={cx(style["toolset-action"], style["custom-tooltip"], style["spacing-toggle"])}>
                    <Icon icon="ui-letter-spacing" />
                    <div className={cx(style["custom-tooltip-content"], style["top"])}>Letter Spacing</div>
                  </DropdownToggle>

                  <DropdownMenu
                    right
                    className={cx(style["shadow"], style["spacing-menu"], style["border-0"], style["rounded"])}>
                    <div className={style["line-controls-wrap"]}>
                      <SliderControll
                        Slider={letterSpacing}
                        setSlider={setLetterSpacing}
                        sliderMin={contextualConfig.LetterSpacing.minValue}
                        sliderMax={contextualConfig.LetterSpacing.maxValue}
                        sliderLabel={"Letter Spacing"}
                        setUpdateContext={setUpdateSpacingContext}
                        setLoadCurrentFormating={setLoadCurrentFormating}
                      />
                    </div>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </li>
            </ul>
            {/* Text style Navs */}
            <Nav tabs className={cx(style["line-tabs"])}>
              <NavItem>
                <NavLink className={activeTab === 0 ? "active" : ""} onClick={() => setActiveTab(0)}>
                  Text Fill
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink className={activeTab === 1 ? "active" : ""} onClick={() => setActiveTab(1)}>
                  Text Outline
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  className={activeTab === 2 ? "active" : ""}
                  onClick={() => {
                    setLoadCurrentFormating(false);
                    setActiveTab(2);
                  }}>
                  Text Transform
                </NavLink>
              </NavItem>
            </Nav>
            {activeTab === 0 && (
              <TextFill
                setTextHtml={setTextHtml}
                loadCurrentFormating={loadCurrentFormating}
                setLoadCurrentFormating={setLoadCurrentFormating}
                textHtml={textHtml}
                setImageId={setImageId}
                documentId={documentId}
              />
            )}
            {activeTab === 1 && (
              <TextOutline
                setTextHtml={setTextHtml}
                setLoadCurrentFormating={setLoadCurrentFormating}
                textDefaultConfig={textDefaultConfig}
              />
            )}
            {activeTab === 2 && (
              <TextTransform
                setTextHtml={setTextHtml}
                loadCurrentFormating={loadCurrentFormating}
                setLoadCurrentFormating={setLoadCurrentFormating}
                textContent={textContent}
                setLetterSpacing={setLetterSpacing}
                changeTransformTypeOnUndo={changeTransformTypeOnUndo}
                changeTransformCatgoryOnUndo={changeTransformCatgoryOnUndo}
                availableFontLists={availableFontLists}
                fitTextToContainer={fitTextToContainer}
              />
            )}
          </div>
        </Col>

        {/* Right Side - text Content area */}
        <Col xs={7} className={cx(style["TMright-pane"], style["pt-3"])}>
          <div
            className={cx(
              style["d-flex"],
              style["align-items-center"],
              style["justify-content-center"],
              style["right-content"]
            )}
            dangerouslySetInnerHTML={{ __html: textHtml?.outerHTML }}></div>
          <div className={style["Mfooter"]}>
            <div className={cx(style["align-items-center"], style["d-flex"])}>
              {props.editable && (
                <Button cssModule={style} color="primary" onClick={updateTextFrame}>
                  Update
                </Button>
              )}
              {!props.editable && (
                <Button cssModule={style} color="primary" onClick={insertTextFrame}>
                  Insert
                </Button>
              )}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};
TextArt.propTypes = {
  closeModal: PropTypes.func.isRequired,
  modalFullScreen: PropTypes.bool,
  setModalFullScreen: PropTypes.func,
  editable: PropTypes.object,
};

export default TextArt;
